/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _module = __webpack_require__(1);
	
	(0, _module.smoothScroll)();
	
	// ------------------------------------------------------------------------
	// スライダー設定
	// ------------------------------------------------------------------------
	/* ---------- スムーススクロール ---------- */
	var indexSliderSetting = function indexSliderSetting() {
	  var indexSlider = new Swiper('.tw-anime-slider .swiper-container', {
	    slidesPerView: 1,
	    centeredSlides: true,
	    loop: true,
	    autoplay: {
	      delay: 3000
	    },
	    navigation: {
	      prevEl: '.tw-anime-slider .tw-anime-slider-nav .tw-anime-slider-nav-prev',
	      nextEl: '.tw-anime-slider .tw-anime-slider-nav .tw-anime-slider-nav-next'
	    },
	    breakpoints: {
	      960: {
	        slidesPerView: 3
	      }
	    }
	  });
	};
	indexSliderSetting();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// ------------------------------------------------------------------------
	// スムーススクロール
	// ------------------------------------------------------------------------
	var smoothScroll = function smoothScroll() {
	  $('a.scroll[href^="#"]').on('click', function () {
	    var linkSpeed = 400;
	    var linkHref = $(this).attr('href');
	    var linkTarget = $(linkHref == '#' || linkHref == '' ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    var linkAdjust = 0;
	    $('html, body').animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, 'swing');
	    return false;
	  });
	};
	
	exports.smoothScroll = smoothScroll;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.bundle.js